import React, { useId } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// styles
import './styles.if.scss'

const TextArea = (props) => {
  const inputId = useId()
  const {
    labelText = null,
    placeholder,
    isError,
    errorMessage,
    rows = 40,
    cols = 50,
    register,
  } = props

  return (
    <div className={clsx('inputForm', isError && 'errorInput')}>
      {labelText && <label htmlFor={`inputForm_${inputId}`}>{labelText}</label>}
      <textarea
        {...register}
        placeholder={placeholder}
        rows={`${rows}`}
        cols={`${cols}`}
      ></textarea>
      {isError && <span className="errorMessage">{errorMessage}</span>}
    </div>
  )
}

TextArea.propTypes = {
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  placeholder: PropTypes.string,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
  register: PropTypes.any,
}

export default TextArea
